module.exports = __webpack_public_path__ + "static/media/armando.ec0aa6db.jpg";